<script>
import General from '@/services/General'
import validationMessages from '@/components/validations'
import { validationMixin } from 'vuelidate'
import { required, requiredIf } from "vuelidate/lib/validators"
import moment from "moment"
import flatPickr from "vue-flatpickr-component"
import vue2Dropzone from "vue2-dropzone"

import "flatpickr/dist/flatpickr.css"
import "vue2-dropzone/dist/vue2Dropzone.min.css"
// import "vue-multiselect/dist/vue-multiselect.min.css"

export default {
  mixins: [validationMixin],
  components: {
    validationMessages,
    flatPickr,
    vueDropzone: vue2Dropzone,
  },
  props: {
    showSectionData: {
      type: Array,
      default: () => [],
    },
    groups: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const defaultStartDate = moment().format("YYYY-MM-DD")
    const defaultEndDate = moment().add(7, 'days').format("YYYY-MM-DD")

    return {
      showModal: false,
      tryingToSubmit: false,
      submitted: false,
      acceptedFileTypeErrorMessage: '',
      acceptedFileTypeError: false,
      dateRangeError: '',
      actionTextOption: [],
      showSecondLevelSelect: false,
      secondLevelOptions: [],
      secondLevelKey: '',
      secondLevelTitle: '',
      secondLevelLoading: false,
      selectedSecondLevel: '',
      popupTypeOptions: [
        { value: 'url', text: 'URL (External Link)' },
        { value: 'deeplink', text: 'Deep Link (App Section)' },
      ],
      recipientOptions: [
        { value: 'ALL', text: 'All Users' },
        { value: 'GROUP', text: 'User segment (group)' },
      ],
      popup: {
        name: '',
        title: '',
        bottom_text: '',
        action: '',
        action_text: '',
        type: '',
        selectedShowSection: '',
        participation_agreement_text: '',
        participation_tnc_url: '',
        recipient: 'ALL',
        group: '',
        file: null,
      },
      duration: {
        start_date: defaultStartDate,
        start_time: '00:00',
        end_date: defaultEndDate,
        end_time: '23:59',
      },
      startDateConfig: {
        dateFormat: "Y-m-d",
        minDate: "today",
      },
      endDateConfig: {
        dateFormat: "Y-m-d",
        minDate: "today",
      },
      timePickerConfig: {
        enableTime: true,
        noCalendar: true,
        dateFormat: "H:i",
        time_24hr: true,
        minuteIncrement: 1,
      },
      dropzoneOptions: {
        url: '/',
        autoProcessQueue: false,
        addRemoveLinks: false,
        thumbnailWidth: 150,
        thumbnailMethod: 'contain',
        maxFilesize: 1,
        maxFiles: 1,
        acceptedFiles: 'image/jpeg,image/png',
        dictMaxFilesExceeded: 'You can only upload one image',
        dictFileTooBig: 'Image is larger than 1MB',
        uploadMultiple: false,
      },
      csrf_token: localStorage.getItem('csrf_token'),
    };
  },
  validations: {
    popup: {
      name: { required },
      title: {
        required: requiredIf(function () {
          return this.typeIsParticipation
        })
      },
      bottom_text: {
        required: requiredIf(function () {
          return this.typeIsParticipation
        })
      },
      participation_agreement_text: {
        required: requiredIf(function () {
          return this.typeIsParticipation
        })
      },
      participation_tnc_url: {
        required: requiredIf(function () {
          return this.typeIsParticipation
        })
      },
      type: { required },
      selectedShowSection: {
        required: requiredIf(function () {
          return this.typeIsDeeplink
        })
      },
      file: { required },
      recipient: { required },
      group: {
        required: requiredIf(function () {
          return this.popup.recipient === 'GROUP'
        })
      }
    },
    duration: {
      start_date: { required },
      start_time: { required },
      end_date: { required },
      end_time: { required },
    },
    selectedSecondLevel: {
      required: requiredIf(function () {
        return this.typeIsDeeplink && this.showSecondLevelSelect
      })
    }
  },
  computed: {
    popupType: {
      get() {
        return this.popup.type
      },
      set(value) {
        this.popup.type = value
      }
    },
    typeIsParticipation() {
      return this.popupType === 'participation'
    },
    typeIsUrl() {
      return this.popupType === 'url'
    },
    typeIsWebview() {
      return this.popupType === 'webview'
    },
    typeIsDeeplink() {
      return this.popupType === 'deeplink'
    },
    hasGroupSelection() {
      return this.popup.recipient === 'GROUP'
    },
    formattedStartDateTime() {
      return this.combineDateTime(this.duration.start_date, this.duration.start_time)
    },
    formattedEndDateTime() {
      return this.combineDateTime(this.duration.end_date, this.duration.end_time)
    },
  },
  methods: {
    refreshPopupData() {
      this.$emit('onRefresh')
    },
    combineDateTime(date, time) {
      if (!date || !time) {
        return ''
      }
      return moment(`${date} ${time}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DD HH:mm")
    },
    validateDateRange() {
      this.dateRangeError = ''
      if (!this.formattedStartDateTime || !this.formattedEndDateTime) {
        return false
      }
      if (moment(this.formattedEndDateTime).isBefore(moment(this.formattedStartDateTime))) {
        this.dateRangeError = 'End date must be after start date.'
        return false
      }
      return true
    },
    createHypePopUp() {
      if (this.acceptedFileTypeError) {
        return
      }
      this.tryingToSubmit = true
      this.submitted = true
      this.$v.$touch()

      const hasValidRange = this.validateDateRange()
      if (this.$v.$invalid || !hasValidRange) {
        this.tryingToSubmit = false
        return
      }

      const formData = new FormData()
      formData.append('name', this.popup.name)
      formData.append('title', this.popup.title)
      formData.append('bottom_text', this.popup.bottom_text)
      formData.append('action_text', this.popup.action_text)
      formData.append('type', this.popupType)

      if (this.typeIsParticipation) {
        formData.append('participation_agreement_text', this.popup.participation_agreement_text)
        formData.append('participation_tnc_url', this.popup.participation_tnc_url)
      } else {
        formData.append('participation_agreement_text', '')
        formData.append('participation_tnc_url', '')
      }

      if (this.typeIsUrl || this.typeIsWebview) {
        formData.append('action', this.popup.action)
      } else if (this.typeIsDeeplink) {
        formData.append('action', this.popup.selectedShowSection || '')
      } else {
        formData.append('action', '')
      }

      if (this.typeIsDeeplink) {
        formData.append('show_section', this.popup.selectedShowSection)
        formData.append('second_level', this.showSecondLevelSelect ? this.selectedSecondLevel : '')
        formData.append('second_level_key', this.secondLevelKey || '')
      } else {
        formData.append('show_section', '')
        formData.append('second_level', '')
      }

      formData.append('date_from', this.formattedStartDateTime)
      formData.append('date_to', this.formattedEndDateTime)
      formData.append('file', this.popup.file)
      formData.append('recipient', this.popup.recipient)
      formData.append('csrf_token', this.csrf_token)

      if (this.hasGroupSelection) {
        formData.append('group_id', this.popup.group)
      }

      General.createHypePopUp(formData)
        .then((response) => {
          const res = response.data.data ? response.data.data : false
          if (res) {
            this.successmsg('Marketing Popup Created!')
            this.refreshPopupData()
            this.closeModal()
          } else {
            this.failedmsg('Failed to create new popup.')
          }
        })
        .catch(error => {
          const resData = error?.response?.data?.error ? error.response.data.error : 'Failed'
          const errorMsg = Array.isArray(resData) ? resData[0] : resData
          this.failedmsg(errorMsg)
        })
        .finally(() => {
          this.tryingToSubmit = false
        })
    },
    closeModal() {
      this.showModal = false
    },
    resetProps() {
      const defaultStartDate = moment().format("YYYY-MM-DD")
      const defaultEndDate = moment().add(7, 'days').format("YYYY-MM-DD")

      this.submitted = false
      this.acceptedFileTypeErrorMessage = ''
      this.acceptedFileTypeError = false
      this.dateRangeError = ''
      this.popup = {
        name: '',
        title: '',
        bottom_text: '',
        action: '',
        action_text: '',
        type: '',
        selectedShowSection: '',
        participation_agreement_text: '',
        participation_tnc_url: '',
        recipient: 'ALL',
        group: '',
        file: null,
      }
      this.duration = {
        start_date: defaultStartDate,
        start_time: '00:00',
        end_date: defaultEndDate,
        end_time: '23:59',
      }
      this.resetSecondLevelState()

      if (this.$refs.hypeDropzone) {
        this.$refs.hypeDropzone.removeAllFiles(true)
      }
    },
    selectFile(files) {
      setTimeout(() => {
        const dropzoneFiles = this.$refs.hypeDropzone?.dropzone?.files || []
        const [file] = files
        if (!file) {
          return
        }

        if (file.size > 1048576) {
          this.acceptedFileTypeErrorMessage = 'Max file size is 1MB.'
          this.acceptedFileTypeError = true
        } else if (!['image/png', 'image/jpeg'].includes(file.type)) {
          this.acceptedFileTypeErrorMessage = 'Only PNG or JPG images are allowed.'
          this.acceptedFileTypeError = true
        } else {
          this.acceptedFileTypeErrorMessage = ''
          this.acceptedFileTypeError = false
        }

        if (dropzoneFiles.length > 1) {
          dropzoneFiles.forEach((value, index) => {
            if (index !== 0) {
              this.$refs.hypeDropzone.removeFile(value)
            }
          })
        }

        this.popup.file = !this.acceptedFileTypeError ? dropzoneFiles[0] : null
      }, 200)
    },
    removeImage() {
      if (this.$refs.hypeDropzone) {
        this.$refs.hypeDropzone.removeAllFiles(true)
      }
      this.popup.file = null
    },
    getActionTextOptions() {
      General.getactionTextOptions()
        .then((response) => {
          this.actionTextOption = response.data.data ? response.data.data : []
          this.syncActionText()
        })
        .catch(() => {
          this.actionTextOption = []
        })
    },
    resetSecondLevelState() {
      this.secondLevelOptions = []
      this.secondLevelKey = ''
      this.secondLevelTitle = ''
      this.selectedSecondLevel = ''
      this.showSecondLevelSelect = false
      this.secondLevelLoading = false
      if (this.$v?.selectedSecondLevel?.$reset) {
        this.$v.selectedSecondLevel.$reset()
      }
    },
    handleShowSectionChange(method) {
      this.resetSecondLevelState()
      if (!method || !this.typeIsDeeplink) {
        return
      }
      const selectedSection = this.showSectionData.find(section => section.method === method)
      if (!selectedSection || !selectedSection.second_level) {
        return
      }
      this.secondLevelKey = selectedSection.second_level
      console.log(this.secondLevelKey)
      this.secondLevelTitle = selectedSection.second_level_description || 'Select an option'
      this.secondLevelLoading = true
      this.getDeeplinkSecondLevel(selectedSection.second_level)
    },
    getDeeplinkSecondLevel(second_level) {
      General.getDeeplinkSecondLevelOptions(second_level)
        .then(response => {
          this.secondLevelOptions = response.data.data || []
          this.showSecondLevelSelect = this.secondLevelOptions.length > 0
        })
        .catch(() => {
          this.secondLevelOptions = []
          this.showSecondLevelSelect = false
        })
        .finally(() => {
          this.secondLevelLoading = false
        })
    },
    syncActionText() {
      if (!this.actionTextOption.length) {
        return
      }

      const defaultOption = this.actionTextOption[0]
      const participationOption = this.actionTextOption[2] || defaultOption
      const deeplinkOption = this.actionTextOption[1] || defaultOption

      if (this.typeIsParticipation) {
        this.popup.action_text = participationOption
      } else if (this.typeIsDeeplink) {
        this.popup.action_text = deeplinkOption
      } else {
        this.popup.action_text = defaultOption
      }
    },
  },
  watch: {
    popupType(newType) {
      this.syncActionText()
      if (newType !== 'deeplink') {
        this.resetSecondLevelState()
        this.popup.selectedShowSection = ''
      }
    },
    actionTextOption(opts) {
      if (opts.length) {
        this.syncActionText()
      }
    },
    'popup.recipient'(value) {
      if (value !== 'GROUP') {
        this.popup.group = ''
      }
    },
    'popup.selectedShowSection'(value) {
      this.handleShowSectionChange(value)
    }
  },
};
</script>

<template>
  <b-modal
    id="add_new_hype_popup"
    size="xl"
    v-model="showModal"
    @hidden="resetProps"
    @shown="getActionTextOptions"
    hide-header
    hide-footer
    body-class="p-0"
    centered
  >
    <div class="marketing-modal">
      <header class="marketing-modal__hero">
        <h2>Create a Marketing Popup</h2>
        <p>Create engaging popups for your sports club app users</p>
      </header>

      <b-form @submit.prevent="createHypePopUp">
        <section class="marketing-card">
          <header class="marketing-card__header">
            <h3>Basic Information</h3>
            <p>Essential details about your popup campaign</p>
          </header>

          <b-form-group
            label="Campaign Name"
            label-for="marketing-campaign-name"
            class="mb-4"
          >
            <b-form-input
              id="marketing-campaign-name"
              v-model.trim="popup.name"
              :class="{ 'is-invalid': submitted && $v.popup.name.$error }"
              placeholder="Enter campaign name (internal use only)"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Campaign Name'"
              :validationName="$v.popup.name"
            />
          </b-form-group>

          <div class="mb-1">
            <label class="form-label d-block">Campaign Duration</label>
          </div>

          <div class="row g-3 flex-wrap">
            <div class="col-12 col-lg-6">
              <div class="marketing-datetime">
                <span class="marketing-datetime__label">From</span>
                <div class="marketing-datetime__inputs">
                  <flat-pickr
                    v-model="duration.start_date"
                    :config="startDateConfig"
                    :class="['form-control', submitted && $v.duration.start_date.$error ? 'is-invalid' : '']"
                    placeholder="Pick a date"
                  />
                  <flat-pickr
                    v-model="duration.start_time"
                    :config="timePickerConfig"
                    :class="['form-control', submitted && $v.duration.start_time.$error ? 'is-invalid' : '']"
                  />
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6">
              <div class="marketing-datetime">
                <span class="marketing-datetime__label">To</span>
                <div class="marketing-datetime__inputs">
                  <flat-pickr
                    v-model="duration.end_date"
                    :config="endDateConfig"
                    :class="['form-control', submitted && $v.duration.end_date.$error ? 'is-invalid' : '']"
                    placeholder="Pick a date"
                  />
                  <flat-pickr
                    v-model="duration.end_time"
                    :config="timePickerConfig"
                    :class="['form-control', submitted && $v.duration.end_time.$error ? 'is-invalid' : '']"
                  />
                </div>
              </div>
            </div>
          </div>
          <div v-if="dateRangeError" class="text-danger mt-2">
            {{ dateRangeError }}
          </div>
        </section>

        <section class="marketing-card">
          <header class="marketing-card__header">
            <h3>Recipients</h3>
            <p>Select who will see this popup</p>
          </header>

          <b-form-group class="mb-0">
            <b-form-select
              v-model="popup.recipient"
              :options="recipientOptions"
              :class="{ 'is-invalid': submitted && $v.popup.recipient.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Target audience'"
              :validationName="$v.popup.recipient"
            />
          </b-form-group>

          <b-form-group
            v-if="hasGroupSelection"
            label="User segment"
            class="mt-4 mb-0"
          >
            <b-form-select
              v-model="popup.group"
              :options="groups.map(group => ({ value: group.group_id, text: group.name }))"
              :class="{ 'is-invalid': submitted && $v.popup.group.$error }"
              placeholder="Select user segment"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'User segment'"
              :validationName="$v.popup.group"
            />
          </b-form-group>
        </section>

        <section class="marketing-card">
          <header class="marketing-card__header">
            <h3>Popup Type</h3>
            <p>Choose where the popup will redirect users</p>
          </header>

          <b-form-group class="mb-4">
            <b-form-select
              v-model="popupType"
              :options="popupTypeOptions"
              :class="{ 'is-invalid': submitted && $v.popup.type.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Popup type'"
              :validationName="$v.popup.type"
            />
          </b-form-group>

          <b-form-group
            v-if="typeIsUrl || typeIsWebview"
            class="mb-4"
          >
            <b-form-input
              v-model.trim="popup.action"
              placeholder="https://example.com"
            />
          </b-form-group>

          <b-form-group
            v-if="typeIsParticipation"
            label="Participation agreement text"
            class="mb-4"
          >
            <b-form-input
              v-model.trim="popup.participation_agreement_text"
              placeholder="Enter participation agreement text"
              :class="{ 'is-invalid': submitted && $v.popup.participation_agreement_text.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Participation agreement text'"
              :validationName="$v.popup.participation_agreement_text"
            />
          </b-form-group>

          <b-form-group
            v-if="typeIsParticipation"
            label="Terms & Conditions URL"
            class="mb-4"
          >
            <b-form-input
              v-model.trim="popup.participation_tnc_url"
              placeholder="https://example.com/terms"
              :class="{ 'is-invalid': submitted && $v.popup.participation_tnc_url.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Participation T&C URL'"
              :validationName="$v.popup.participation_tnc_url"
            />
          </b-form-group>

          <b-form-group
            v-if="typeIsDeeplink"
            label="App section"
            class="mb-0"
          >
            <b-form-select
              v-model="popup.selectedShowSection"
              :options="showSectionData.map(section => ({ value: section.method, text: section.description }))"
              :class="{ 'is-invalid': submitted && $v.popup.selectedShowSection.$error }"
              placeholder="Select an app section"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'App section'"
              :validationName="$v.popup.selectedShowSection"
            />
          </b-form-group>

          <b-form-group
            v-if="showSecondLevelSelect"
            :label="secondLevelTitle || 'App subsection'"
            class="mt-4 mb-0 position-relative"
          >
            <b-form-select
              v-model="selectedSecondLevel"
              :options="secondLevelOptions.map(option => ({ value: option.id, text: option.name }))"
              :disabled="secondLevelLoading"
              :class="{ 'is-invalid': submitted && $v.selectedSecondLevel.$error }"
            />
            <div v-if="secondLevelLoading" class="select-loader">
              <b-spinner small />
            </div>
            <validationMessages
              v-if="submitted"
              :fieldName="secondLevelTitle || 'App subsection'"
              :validationName="$v.selectedSecondLevel"
            />
          </b-form-group>
        </section>
        <section class="marketing-card">
          <header class="marketing-card__header marketing-card__header--icon">
            <i class="uil uil-image"></i>
            <div>
              <h3>Popup Image</h3>
              <p>Image size: 980x1080 pixels, Max file size: 1MB. The button is generated automatically and should not be part of the image (be aware of the safe zone).</p>
            </div>
          </header>

          <div
            :class="[
              'marketing-upload',
              submitted && $v.popup.file.$error ? 'is-invalid' : '',
              acceptedFileTypeError ? 'has-error' : ''
            ]"
          >
            <vue-dropzone
              id="hype-dropzone"
              ref="hypeDropzone"
              :options="dropzoneOptions"
              :use-custom-slot="true"
              @vdropzone-files-added="selectFile"
              no-progress-bar
            >
              <div class="marketing-upload__placeholder">
                <i class="uil uil-import"></i>
                <span>Drag and drop an image, or click to browse</span>
                <small>PNG, JPG up to 1MB</small>
              </div>
            </vue-dropzone>
          </div>

          <div class="d-flex align-items-center gap-3 mt-3" v-if="popup.file">
            <span class="text-muted small">{{ popup.file.name }}</span>
            <b-button size="sm" variant="outline-danger" @click="removeImage">Remove</b-button>
          </div>

          <validationMessages
            v-if="submitted"
            :fieldName="'Popup image'"
            :validationName="$v.popup.file"
          />
          <p v-if="acceptedFileTypeError" class="text-danger mt-2">{{ acceptedFileTypeErrorMessage }}</p>
        </section>

        <input type="hidden" name="csrf_token" v-model="csrf_token">

        <footer class="marketing-modal__footer">
          <b-button variant="outline-secondary" @click="closeModal">Cancel</b-button>
          <b-button variant="dark" type="submit" :disabled="tryingToSubmit">
            <b-spinner v-if="tryingToSubmit" small class="me-2" />
            Create Popup
          </b-button>
        </footer>
      </b-form>
    </div>
  </b-modal>
</template>

<style scoped>
.marketing-modal {
  padding: 32px;
  background: #f7f8fb;
}

.marketing-modal__hero {
  margin-bottom: 24px;
}

.marketing-modal__hero h2 {
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 8px;
  color: #151a2d;
}

.marketing-modal__hero p {
  margin: 0;
  color: #5f6b7d;
  font-size: 16px;
}

.marketing-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 28px;
  margin-bottom: 24px;
  box-shadow: 0 12px 32px rgb(15 23 42 / 6%);
}

.marketing-card__header {
  margin-bottom: 24px;
}

.marketing-card__header h3 {
  margin: 0 0 4px;
  font-size: 20px;
  font-weight: 600;
  color: #151a2d;
}

.marketing-card__header p {
  margin: 0;
  color: #5f6b7d;
}

.marketing-card__header--icon {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.marketing-card__header--icon i {
  font-size: 32px;
  color: #151a2d;
  line-height: 1;
}

.marketing-datetime {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.marketing-datetime__label {
  font-weight: 600;
  color: #151a2d;
}

.marketing-datetime__inputs {
  display: flex;
  gap: 12px;
  align-items: center;
}

.marketing-datetime__inputs .form-control {
  padding: 12px 16px;
  border-radius: 12px;
  background: #f1f3f7;
  border: 1px solid transparent;
}

.marketing-datetime__inputs .form-control:focus {
  border-color: #6366f1;
  background: #ffffff;
  box-shadow: none;
}

.marketing-upload {
  border: 2px dashed #d3d8e6;
  border-radius: 16px;
  background: #f7f8fb;
  padding: 32px;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.select-loader {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
  background: rgba(255, 255, 255, 0.85);
  border-radius: 999px;
}

.marketing-upload.is-invalid {
  border-color: #f97373;
}

.marketing-upload.has-error {
  border-color: #f97373;
  background: #fff5f5;
}

.marketing-upload__placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #5f6b7d;
  font-size: 14px;
  text-align: center;
}

.marketing-upload__placeholder i {
  font-size: 32px;
  color: #151a2d;
}

.marketing-upload__placeholder small {
  color: #a0aec0;
}

.marketing-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 12px;
}

@media (max-width: 767.98px) {
  .marketing-modal {
    padding: 20px;
  }

  .marketing-card {
    padding: 20px;
  }

  .marketing-datetime__inputs {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>